enum FeatureRequestKey {
  ADVANCED_REPORTING = "advancedReporting",
  DATA_MERGING = "dataMerging",
  DEMOGRAPHICS = "demographics",
  EMAIL = "email",
  LEAD_FINDER_ADVANCED = "leadFinderAdvanced",
  LEAD_FINDER_ELITE = "leadFinderElite",
  LEAD_FINDER_STARTER = "leadFinderStarter",
  MILEAGE_TRACKER = "mileageTracker",
  ONBOARDING = "onboarding",
  PHI = "phi",
  RESOURCES = "resources",
  TERRITORIES = "territories",
}

export default FeatureRequestKey;
